export default __webpack_public_path__ + "static/media/gotv.8179e25b.svg";